<template>
    <div class="limit-sale-form">
      <el-form-item label="限购规则:" prop="limitSaleInfo">
        <el-radio-group v-model="formData.limitSale"  @change="handleLimitSaleChange">
          <el-radio :label="false">不限购</el-radio>
          <el-radio :label="true">限购</el-radio>
          <span class="tip-text">(设置后对全部商品均生效)</span>
        </el-radio-group>
      </el-form-item>
      <template v-if="formData.limitSale">
        <el-form-item>
            <!-- 限购周期部分 -->
            <div class="limit-section">
            <el-form-item 
                label="限购周期:" 
                required
                :rules="[{ required: true, message: '请选择限购周期' }]"
            >
                <div class="period-row">
                <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyyMMdd"
                    @change="handleDateChange"
                />
                <el-tooltip placement="right" effect="light">
                    <div slot="content">超过截止日期后将不再进行限购</div>
                    <i class="el-icon-question"></i>
                </el-tooltip>
                </div>
            </el-form-item>
            </div>
    
            <!-- 购买规则部分 -->
            <div class="limit-section">
            <el-form-item 
                label="单个买家购买规则:" 
                required
                :rules="[{ required: true, message: '请完善购买规则' }]"
            >
                <div class="rule-row">
                <span class="label-text">每</span>
                <el-select 
                    v-model="formData.frequency" 
                    style="width: 100px"
                    @change="handleFrequencyChange"
                >
                  <el-option 
                    :value="-1" 
                    label="整个限购周期"
                  />
                  <el-option 
                    v-for="day in 31" 
                    :key="day"
                    :value="day" 
                    :label="`${day}天`" 
                  />
                </el-select>
                <span class="label-text">每个用户限购</span>
                <el-input-number 
                    v-model="formData.count"
                    :min="1"
                    :max="99"
                    :precision="0"
                    style="width: 120px"
                    @change="handleCountChange"
                />
                <span class="label-text">份</span>
                <el-tooltip placement="right" effect="light">
                    <div slot="content">如您在标题中添加了限购信息，请与限购数量保持一致</div>
                    <i class="el-icon-question"></i>
                </el-tooltip>
                </div>
            </el-form-item>
            <div class="tip-info">
                温馨提示：在限购周期内按照每个买家进行限制，请合理设置（限购数量对每个规则单独生效，比如限购10份，则规格1、规格2、规格n可各买10份）
            </div>
            </div>
        </el-form-item>
      </template>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LimitSaleForm',
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: {
        type: Object,
        default: () => ({
          limitSale: false,
          begin: '',
          end: '',
          type: 1,
          frequency: 1,
          count: 0
        })
      }
    },
    data() {
      return {
        dateRange: [],
        localFormData: null, // 本地数据
        rules: {
            dateRange: [{ required: true, message: '请选择限购周期' }],
            frequency: [{ required: true, message: '请选择限购天数' }],
            count: [{ required: true, message: '请输入限购数量' }]
        }
      }
    },
    computed: {
      formData: {
        get() {
          const data = this.localFormData || this.value || {};
          // 处理 frequency 显示逻辑
          if (data.type === 2) {
            return {
              ...data,
              frequency: -1  // 当 type 为 2 时，显示整个限购周期
            };
          }
          return data;
        },
        set(val) {
          this.localFormData = val;
          this.$emit('change', JSON.parse(JSON.stringify(val)));
        }
      }
    },
    watch: {
      value: {
        handler(val) {
          // 处理初始数据
          if(val){
            const formData = {
              ...val,
              frequency: val.type === 2 ? -1 : (val.frequency || 1)
            };
            this.localFormData = JSON.parse(JSON.stringify(formData));
            if (val.begin && val.end) {
              this.dateRange = [val.begin, val.end];
            }
          }
        },
        immediate: true,
        deep: true
      },
    },
    created() {
      // 在 created 中初始化数据
       this.localFormData = JSON.parse(JSON.stringify(this.value));
    },
    methods: {
        handleFrequencyChange(val) {
          const newData = {
            ...this.formData,
            frequency: val === -1 ? 1 : val,  // 存储时，如果是整个限购周期，frequency 存 1
            type: val === -1 ? 2 : 1
          };
          this.$emit('change', newData);
          this.localFormData = newData;
        },
        handleCountChange(val) {
          const newData = {
            ...this.formData,
            count: val
          };
          this.$emit('change', newData);
          this.localFormData = newData;
        },
      handleLimitSaleChange(val) {
        const today = new Date();
        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1); // 当月第一天
        const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0); // 当月最后一天

        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}${month}${day}`;
        };

        const newData = val ? {
          ...this.formData,
          limitSale: true,
          count: 1,
          type: 1,  // 重置为默认类型
          frequency: 1,  // 重置为默认天数
          begin: formatDate(firstDay),
          end: formatDate(lastDay)
        } : {
          limitSale: false,
          begin: '',
          end: '',
          type: 1,
          frequency: 1,
          count: 0
        };
        this.$emit('change', newData);
        this.localFormData = newData;
        // 同步更新日期选择器的显示
        if (val) {
          this.dateRange = [formatDate(today), formatDate(nextMonth)];
        } else {
          this.dateRange = [];
        }
      },
      handleDateChange(val) {
        const newData = {
          ...this.formData,
          begin: val ? val[0] : '',
          end: val ? val[1] : ''
        };
        this.$emit('change', newData);
        this.localFormData = newData;
      },
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .limit-sale-form {
    .limit-section {
        background: #f5f7fa;
        padding: 16px;
        border-radius: 4px;
    }

    .period-row, .rule-row {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .label-text {
        margin: 0 8px;
    }

    .tip-text {
        color: #909399;
        font-size: 12px;
        margin-left: 8px;
    }

    .tip-info {
        color: #909399;
        font-size: 12px;
        margin-top: 8px;
        line-height: 1.4;
    }

    .el-icon-question {
        color: #909399;
        cursor: pointer;
        margin-left: 4px;
    }
    }
  </style>